export enum ValidationItemUpdateMode {
  Manual = 0,
  Active = 1,
  Expired = 100,
  ExpiredManual = 101,
}

export const validationItemUpdateModeAsString = new Map([
  [ValidationItemUpdateMode.Active, "Active"],
  [ValidationItemUpdateMode.Manual, "Manual"],
  [ValidationItemUpdateMode.Expired, "Expired"],
  [ValidationItemUpdateMode.ExpiredManual, "Expired Manual"],
]);
